import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PRINTED_NAME_MAX_LENGTH } from '../../constants';

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const PrintedNameField = ({
  value,
  onChange,
  disabled = false
}: Props) => {
  const { t } = useTranslation('customerReview');

  return (
    <TextField
      fullWidth
      label={t('acknowledgment.printedName')}
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      required
      inputProps={{
        maxLength: PRINTED_NAME_MAX_LENGTH,
        readOnly: disabled
      }}
      sx={{ mb: 3 }}
    />
  );
};
